import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-weblink-footer',
  templateUrl: './weblink-footer.component.html',
  styleUrls: ['./weblink-footer.component.scss']
})
export class WeblinkFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
